import { assert_array_typeof_string } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { FIELD_GRID2D_MODE__base } from '../../_base/FIELD_GRID2D_MODE__base';
import { FIELD__list_lora } from '../../_primitives/list/FIELD__list_lora';
import { FIELD__ml_asset_lora } from './FIELD__ml_asset_lora';

export class FIELD_GRID2D_MODE__lora_vs_lora extends FIELD_GRID2D_MODE__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_GRID2D_MODE__LORA_VS_LORA;

  /*
   *
   */
  hashes_pairs!: string[][];
  hashes: string[];

  /*
   *
   */

  //todo: finish
  // @FIELD_PRIMITIVE__int.init_as_field(
  //   {
  //     value: CONSTANTS__shared.NUMBER_EMPTY_VALUE,
  //     value_range: DTO__number_range.MINUS_ONE.clone(),
  //     values_allowed: DTO__number_range.MINUS_ONE.clone(),
  //     //
  //     slider_step: 1,
  //     slider_step_values: [1, 2, 3, 4, 5],
  //   },
  //   { ui__has_component: false, grid2d__can_be_dimension: false },
  // )
  // tokens_positions!: FIELD_PRIMITIVE__int;

  /*
   *
   */

  get_grid2d_side_size() {
    return Math.max(this.hashes.length, 1);
  }

  get grid2d_dimension_values() {
    return this.hashes_pairs;
  }

  /*
   *
   */

  constructor() {
    super();

    this.hashes_pairs = [];
    this.hashes = [];
  }

  init_loras(loras: FIELD__ml_asset_lora[]) {
    this.hashes_pairs = [];

    this.hashes = loras.map(item => item.model.get_value());

    for (let y = 0; y < this.hashes.length; y++) {
      const token_y = this.hashes[y];

      for (let x = 0; x < this.hashes.length; x++) {
        const token_x = this.hashes[x];

        let pair = [];
        pair.push(token_y);

        if (token_y != token_x) pair.push(token_x);

        this.hashes_pairs.push(pair);
      }
    }

    if (this.hashes_pairs.is_empty()) this.hashes_pairs = [[]];

    /*
     *
     */

    //todo:finish
    // if (this.tokens_pairs.is_empty()) {
    //   this.tokens_pairs.push([]);
    //   this.tokens_positions.set_value_range(DTO__number_range.MINUS_ONE.clone());
    //   this.tokens_positions.values_allowed = DTO__number_range.MINUS_ONE.clone();

    //   this.tokens_positions.set_value(DTO__number_range.MINUS_ONE.min);
    // } else {
    //   let values_allowed = new DTO__number_range(1, this.tokens.length);
    //   this.tokens_positions.values_allowed = values_allowed.clone();

    //   let values_range_current = this.tokens_positions.get_value_range();

    //   let value_range_new = values_allowed.clamp_range(values_range_current);
    //   this.tokens_positions.set_value_range(value_range_new);

    //   this.tokens_positions.set_value(value_range_new.min);
    // }
  }

  grid2d_dimension__set_value(loras_pair: any) {
    assert_array_typeof_string(loras_pair);

    this.hashes = [...loras_pair];
    this.hashes_pairs = [[]];
  }

  grid2d_dimension__apply_for(graph: DTO_GRAPH__instance) {
    let fields_map = graph.fields__get_map();

    let loras_lists = fields_map.values().filter(field => field instanceof FIELD__list_lora);

    for (let loras_list of loras_lists) {
      let items = [...loras_list.items];

      for (let item of items) {
        if (this.hashes.includes(item.model.get_value())) continue;

        let edges_to_delete = graph.edges__get_related_to_fields([item]);
        graph.edges__delete(edges_to_delete);

        loras_list.item_remove(item);
      }
    }

    graph.field__replace(this);
  }
}
